import React, { useEffect, useState } from 'react';
import { Box, Breadcrumbs, CircularProgress, Grid, Link, Stack } from '@mui/material';
import Interacoes from '../../components/interacoes';
import EmpresasAssociadas from '../../components/empresaAssociada';
import DocumentosAssociados from '../../components/documentosAssociados';
import PessoasAssociadas from '../../components/pessoasAssociadas';
import InfoContactoCliente from '../../components/infoContactoCliente';
import CotacoesList from '../../components/cotacoes';
const CrmPessoasDetailsView = ({ $state, CrmService, AuthorizationService }) => {
    const [pessoa, setPessoa] = useState(null);
    const [social, setSocial] = useState(null);
    //const [isLoading, setIsLoading] = useState<boolean>(true);
    const fetchData = async () => {
        try {
            const getPessoa = await CrmService.findPessoaById($state.params.id);
            if (!AuthorizationService.canPerform('crmListarContactos')) {
                $state.go('app.dashboard');
            }
            if (getPessoa?.redesSociais) {
                const parsedSocial = JSON.parse(getPessoa.redesSociais);
                setSocial(parsedSocial);
            }
            else {
                setSocial([]);
            }
            setPessoa(getPessoa);
        }
        catch (e) {
            console.log(e);
        }
        //setIsLoading(false);
    };
    useEffect(() => {
        if (!pessoa) {
            fetchData();
        }
    }, []);
    return (<Box sx={{ mt: 2, pl: 1, pr: 1 }}>
      {pessoa ? (<Box>
          <Breadcrumbs aria-label='breadcrumb'>
            <Link underline='none' color='inherit'>
              CRM
            </Link>
            <Link underline='hover' color='text.primary' href={$state.href('app.crm.pessoas.list')}>
              Contactos
            </Link>
           
          </Breadcrumbs>

          <Box sx={{ mt: 4 }}>
            <InfoContactoCliente $state={$state} pessoa={pessoa} edit={true}></InfoContactoCliente>
          </Box>

          <Grid container sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <Stack spacing={4}>
                <Interacoes $state={$state} CrmService={CrmService} contacto={pessoa}/>

                <CotacoesList $state={$state} CrmService={CrmService} contacto={pessoa.id}/>

                <EmpresasAssociadas $state={$state} CrmService={CrmService} user={pessoa}/>

                <PessoasAssociadas $state={$state} CrmService={CrmService} user={pessoa}/>

                <DocumentosAssociados $state={$state} CrmService={CrmService} user={pessoa} readOnly={false}/>
              </Stack>
            </Grid>
          </Grid>
        </Box>) : (<Stack direction='row' justifyContent='center' alignItems='flex-start' sx={{ mt: 4 }}>
          <CircularProgress size={50}/>
        </Stack>)}
    </Box>);
};
export default CrmPessoasDetailsView;
